// Listes partagées entre postes (accueil, caisse, médecins) : rafraîchies en
// arrière-plan pour qu'une saisie faite ailleurs apparaisse sans recharger la
// page, et éviter ainsi les doublons. La clé de requête porte page, filtres et
// recherche : le rafraîchissement les conserve.
export const LIVE_LIST_OPTIONS = {
  refetchInterval: 20_000,
  refetchIntervalInBackground: false, // onglet masqué → pas de polling
  refetchOnWindowFocus: true, // retour sur l'onglet → rafraîchi aussitôt
  keepPreviousData: true, // pas de squelette pendant le rafraîchissement
} as const;
